<template>
  <div>
    <div class="breadcrumb">
      <h1 style="color: #AC8400;">Referral Codes</h1>
    </div>

    <div class="separator-breadcrumb border-top"></div>
    <div class="row mb-4">
      <div class="col-md-12 mb-4">
        <!-- Active -->
        <div class="card text-left">
          <div class="card-body">
            <router-link
              :to="{ path: `/lps/affiliate/referral-code/add/${+this.$route.params.id}`}"
              type="button"
              class="btn btn-primary ml-3 float-left"
              >Add</router-link
            >

            <div class="row mb-3">

              <div
                class="col-12 d-flex flex-column flex-sm-row pr-3"
              >
                <span class="m-auto"></span>

                <div
                  class="btn-group"
                  role="group"
                >
                  <button
                    class="btn btn-secondary"
                    id="btn-inactive"
                    type="button"
                    :class="this.active ? 'change-background': ''"
                    @click="active = !active"
                  >
                    Active
                  </button>
                  <button
                    class="btn btn-secondary"
                    id="btn-inactive"
                    type="button"
                    :class="!this.active ? 'change-background': ''"
                    @click="active = !active"
                  >
                    Inactive
                  </button>
                </div>
              </div>
            </div>
            <div v-show="active" class="table-responsive">
              <table
                id="table"
                class="display table table-striped table-bordered"
                style="width:100%; text-align: center;"
              >
                <thead>
                  <tr>
                    <th>No.</th>
                    <th>Name</th>
                    <th>Code</th>
                    <th>Type</th>
                    <th>Points</th>
                    <th>Start Date</th>
                    <th>Expiry Date</th>
                    <th>Status</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in active_lists" :key="index">
                    <td>{{ index+1 }}</td>
                    <td>{{ item.referralDetail.name }}</td>
                    <td>{{ item.account_number }}</td>
                    <td>{{ item.referralDetail.type == 1 ? 'Media' : 'Promoters' }}</td>
                    <td>{{ item.referralDetail.user_points  }}</td>
                    <td>{{ item.referralDetail.start_date  }}</td>
                    <td>{{ item.referralDetail.expiry_date  }}</td>
                    <td>{{ item.referralDetail.active == 1 ? 'Active' : 'Inactive' }}</td>
                    <td>
                      <router-link
                        :to="{path: '/lps/affiliate/referral-code/edit/'+ item.id }"
                        type="button"
                        class="btn btn-primary btn-rounded btn-block"
                        >View Details</router-link
                      >
                    </td>
                    
                  </tr>
                </tbody>
              </table>
            </div>

            <div v-show="!active" class="table-responsive">
              <table
                id="table"
                class="display table table-striped table-bordered"
                style="width:100%; text-align: center;"
              >
                <thead>
                   <tr>
                    <th>No.</th>
                    <th>Name</th>
                    <th>Code</th>
                    <th>Type</th>
                    <th>Points</th>
                    <th>Start Date</th>
                    <th>Expiry Date</th>
                    <th>Status</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in inactive_lists" :key="index">
                   <td>{{ index+1 }}</td>
                    <td>{{ item.referralDetail.name }}</td>
                    <td>{{ item.account_number }}</td>
                    <td>{{ item.referralDetail.type == 1 ? 'Media' : 'Promoters' }}</td>
                    <td>{{ item.referralDetail.user_points  }}</td>
                    <td>{{ item.referralDetail.start_date  }}</td>
                    <td>{{ item.referralDetail.expiry_date  }}</td>
                    <td>{{ item.referralDetail.active == 1 ? 'Active' : 'Inactive' }}</td>
                    <td>
                      <router-link
                        :to="{path: '/lps/affiliate/referral-code/edit/'+ item.id }"
                        type="button"
                        class="btn btn-primary btn-rounded btn-block"
                        >View Details</router-link
                      >
                    </td>
                    
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import axios from "axios";

export default {
  name: "referral-listings",

  data() {
    return {
      active_lists: [],
      inactive_lists: [],
      active: true
    };
  },

  methods: {
    async loadEntity() {
      let token = localStorage.getItem("token");

      // check if has token
      if (token !== null) {
        token = JSON.parse(token);
        token = token.access_token;
        try {
          let result = await axios.get(axios.lpsURL + "/referral_code?affiliate_id="+this.$route.params.id, {
            headers: {
              Authorization: "Bearer " + token
            }
          });
          result.data.data.forEach(item => {
            if(item.referralDetail.active) {
              this.active_lists.push(item)
            } else {
              this.inactive_lists.push(item)
            }
          });

        } catch (error) {
          console.log(error);
        }
      }
    },

    goTo() {
      return "/affiliate/" + 1;
    },

    killDatatable() {
      $(".table")
        .DataTable()
        .destroy();
    },

    createDatatable() {
      $(".table").DataTable({
        dom: "Bfrtip",
        pageLength: 5,
        lengthMenu: [
          [5, 10, 25, 50, -1],
          ["5 rows", "10 rows", "25 rows", "50 rows", "Show all"]
        ],
        buttons: [
          {
            extend: "excelHtml5",
            exportOptions: {
              columns: [0, 1, 2, 3, 4,5,6,7]
            },
            filename: 'Referral Code List',
            title: 'Referral Code List',

          },
          {
            extend: "pdfHtml5",
            exportOptions: {
              columns: [0, 1, 2, 3, 4,5,6,7]
            },
            filename: 'Referral Code List',
            title: 'Referral Code List',

          }
        ]
      });
    }
  },

  async created() {
    await this.loadEntity();
    this.createDatatable();
  },

  mounted() {}
};
</script>

<style>
.change-background {
  background-color: #5f5f5f;
  color: white;
}
</style>
